import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GitCompareArrows } from 'lucide-react';
import { useT } from '../services/i18n';

const engineOf = (v) => (v.engine && (v.engine.name || v.engine)) || '';
const key = (v) => `${v.brand}|${v.model}|${engineOf(v)}`;
const selectCls = 'border border-gray-300 rounded-md px-2 py-1.5 text-sm bg-white max-w-[200px] truncate';

// Garage: pick two different vehicles (model + exact engine) and open the parts comparison
const GarageCompare = ({ vehicles }) => {
  const { t } = useT();
  const navigate = useNavigate();
  const models = [...new Map(vehicles.map((v) => [key(v), { brand: v.brand, model: v.model, engine: engineOf(v) }])).values()];
  const [a, setA] = useState(0);
  const [b, setB] = useState(1);
  const [c, setC] = useState(-1);
  if (models.length < 2) return null;
  const picks = [a, b, ...(c >= 0 ? [c] : [])];
  const valid = new Set(picks).size === picks.length;
  const go = () => {
    if (!valid) return;
    const p = new URLSearchParams();
    picks.forEach((i, k) => { p.set(`${'abc'[k]}_brand`, models[i].brand); p.set(`${'abc'[k]}_model`, models[i].model); if (models[i].engine) p.set(`${'abc'[k]}_engine`, models[i].engine); });
    navigate(`/comparaison-modeles?${p.toString()}`);
  };
  const label = (m) => `${m.brand} ${m.model}${m.engine ? ` · ${m.engine}` : ''}`;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 p-3" data-testid="garage-compare">
      <span className="text-sm font-medium text-gray-800 inline-flex items-center gap-1.5 mr-1"><GitCompareArrows size={16} className="text-orange-500" /> {t('garage.compareTitle')}</span>
      <select data-testid="garage-compare-a" value={a} onChange={(e) => setA(Number(e.target.value))} className={selectCls}>
        {models.map((m, i) => <option key={key(m)} value={i}>{label(m)}</option>)}
      </select>
      <span className="text-xs font-bold text-gray-400">VS</span>
      <select data-testid="garage-compare-b" value={b} onChange={(e) => setB(Number(e.target.value))} className={selectCls}>
        {models.map((m, i) => <option key={key(m)} value={i}>{label(m)}</option>)}
      </select>
      {models.length > 2 && (
        <>
          <span className="text-xs font-bold text-gray-400">VS</span>
          <select data-testid="garage-compare-c" value={c} onChange={(e) => setC(Number(e.target.value))} className={selectCls}>
            <option value={-1}>{t('garage.compareThird')}</option>
            {models.map((m, i) => <option key={key(m)} value={i}>{label(m)}</option>)}
          </select>
        </>
      )}
      <button type="button" onClick={go} disabled={!valid} data-testid="garage-compare-button" className="ml-auto inline-flex items-center gap-1 text-sm font-medium text-white bg-[#1e3a5f] hover:bg-orange-500 disabled:bg-gray-300 px-3 py-1.5 rounded-full transition-colors">{t('garage.compareButton')}</button>
    </div>
  );
};

export default GarageCompare;
